import React, { useEffect, useRef } from "react";

/** Keep sound attached to the visible page, including retained router screens. */
export default function UseCaseFilm({ src, poster, label, children }) {
  const ref = useRef(null);
  useEffect(() => {
    const video = ref.current;
    const pause = () => {
      if (video && !video.paused) video.pause();
    };
    const visibility = () => {
      if (document.hidden) pause();
    };
    const observer =
      typeof IntersectionObserver === "undefined"
        ? null
        : new IntersectionObserver(([entry]) => {
            if (!entry.isIntersecting) pause();
          });
    if (video) observer?.observe(video);
    document.addEventListener("visibilitychange", visibility);
    return () => {
      observer?.disconnect();
      document.removeEventListener("visibilitychange", visibility);
      pause();
    };
  }, [src]);
  return (
    <video
      ref={ref}
      controls
      playsInline
      preload="none"
      poster={poster}
      aria-label={label}
    >
      <source src={src} type="video/mp4" />
      {children}
    </video>
  );
}
